import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const MobileNumberInput = ({ 
  value, 
  onChange, 
  error, 
  disabled,
  onSubmit 
}) => {
  const handleChange = (e) => {
    const inputValue = e?.target?.value?.replace(/\D/g, '');
    if (inputValue?.length <= 10) {
      onChange(inputValue);
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && value?.length === 10 && !disabled) {
      onSubmit();
    }
  };

  return (
    <div className="space-y-2">
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 flex items-center gap-2 pointer-events-none">
          <Icon name="Phone" size={18} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground font-medium">+91</span>
        </div>
        <Input
          type="tel"
          value={value}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          placeholder="Enter 10-digit mobile number"
          error={error}
          disabled={disabled}
          maxLength={10}
          className="pl-20"
          label="Mobile Number"
          description="You can register up to 3 teams with this number (1 each in U14 Boys, U16 Boys, and U15 Girls)"
          required
        />
      </div>
    </div>
  );
};

export default MobileNumberInput;